import { useContext, useEffect } from 'react';
import { AdContext } from './AdContext';
import { AdProviders, ADUNIT_PROVIDER_SAFETY_KEY, FREESTAR_PREFIX } from './constants';
import { isSSR } from './utils';
import { BiContext } from '@wix/da-bi/pkg/BiLogger.context';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
export function useAdUnit(provider, unitId, safety, options) {
    const { DaAds  } = useContext(AdContext);
    // TODO if freestar is perma give them their own ID set
    if (provider === AdProviders.Freestar) {
        unitId = `${FREESTAR_PREFIX}${unitId}`;
    }
    // Add safety to the options
    options[ADUNIT_PROVIDER_SAFETY_KEY[provider]] = safety;
    // In ssr we register on render
    if (isSSR()) {
        DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, safety, options);
    }
    const biContext = useContext(BiContext);
    const publicSession = useContext(SessionContext);
    // On client we have side effect + kill on unmount
    useEffect(()=>{
        if (!isSSR()) {
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, safety, options);
        }
        return ()=>{
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.killUnit(unitId, safety);
        };
    // only run on safety change, DaAds will handle recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        safety
    ]);
    // sync bi data
    useEffect(()=>{
        if (!isSSR()) {
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.setBiContext(biContext, publicSession);
        }
    }, [
        DaAds,
        biContext,
        publicSession
    ]);
    return {
        // suppress + danger is hack that forces current react (16+)
        // to NOT clear the inner element on hydration, this stops
        // the clobbering of the adunit on first client render.
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: ''
        },
        id: unitId,
        'data-canfs': 'yes',
        'data-safety': safety,
        advertIsOff: safety === 'off'
    };
}
